export const DEFAULT_CONSTANT_SYMBOL = '0308';
export const RETURN_CARD_PAYMENT_AMOUNT = 0.04;
export const PAYMENT_STATUS_TYPES = {
  SUCCESS: 'success',
  FAILURE: 'failure',
  UNCHECKED: 'unchecked',
};

export const PAYMENT_STATUS_INIT = '10';
export const PAYMENT_STATUS_REDIRECT_TO_IB = '20';
export const PAYMENT_STATUS_ONLINE_CHECKIN_TRUE = '30';
export const PAYMENT_STATUS_ONLINE_CHECKIN_FALSE = '1010';
export const PAYMENT_STATUS_MAIL_CHECKIN_TRUE = '40';
export const PAYMENT_STATUS_MAIL_CHECKIN_FALSE = '1020';
export const PAYMENT_STATUS_STORNO_TIMEOUT = '1030';
export const PAYMENT_STATUS_STORNO_NEW_TRANS = '1040';
export const PAYMENT_STATUS_FINISH = '50';

export const PAYMENT_STATUS_MAP = {
  [PAYMENT_STATUS_INIT]: PAYMENT_STATUS_TYPES.UNCHECKED,
  [PAYMENT_STATUS_REDIRECT_TO_IB]: PAYMENT_STATUS_TYPES.UNCHECKED,
  [PAYMENT_STATUS_ONLINE_CHECKIN_TRUE]: PAYMENT_STATUS_TYPES.SUCCESS,
  [PAYMENT_STATUS_ONLINE_CHECKIN_FALSE]: PAYMENT_STATUS_TYPES.UNCHECKED,
  [PAYMENT_STATUS_MAIL_CHECKIN_TRUE]: PAYMENT_STATUS_TYPES.SUCCESS,
  [PAYMENT_STATUS_MAIL_CHECKIN_FALSE]: PAYMENT_STATUS_TYPES.FAILURE,
  [PAYMENT_STATUS_STORNO_TIMEOUT]: PAYMENT_STATUS_TYPES.FAILURE,
  [PAYMENT_STATUS_STORNO_NEW_TRANS]: PAYMENT_STATUS_TYPES.FAILURE,
  [PAYMENT_STATUS_FINISH]: PAYMENT_STATUS_TYPES.SUCCESS,
};

export const PAYMENT_PROVIDER_SLSP = 'SLSP_PAY_ECARE';
export const PAYMENT_PROVIDER_TATRA_PAY = 'TATRA_PAY_ECARE';
export const PAYMENT_PROVIDER_CARD_PAY = 'CARD_PAY_ECARE';
export const PAYMENT_PROVIDER_COMFORT_PAY = 'COMFORT_PAY';
export const PAYMENT_PROVIDER_COMFORT_PAY_ACTIVATION = 'COMFORT_PAY_ACTIVATION_ECARE';
export const PAYMENT_PROVIDER_ON_DEMAND = 'ON_DEMAND_ECARE';
export const RECURRING_PAYMENT_PROVIDERS = [PAYMENT_PROVIDER_COMFORT_PAY];
export const NONRECURRING_PAYMENT_PROVIDERS = [
  PAYMENT_PROVIDER_SLSP,
  PAYMENT_PROVIDER_TATRA_PAY,
  PAYMENT_PROVIDER_CARD_PAY,
];
